import { AxiosInstance } from 'axios';
import { insertId } from '../../insertId';
import { toResponse } from '../../genericToResponse';
import { IParameter } from 'src/views/Admin/Parameters/types';

export default (api: AxiosInstance, url: string) => async (
  parameter: IParameter
) => {
  const urlWithId = insertId(url, parameter.id);
  const response = await api.put(urlWithId, parameter);
  return toResponse(response.data) as IParameter;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/parameters/update.ts